import React from "react";
import { faChevronLeft } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";

import "./BackPage.scss";

export default function BackPage() {

  const navigate = useNavigate()

  return (
    <div className="goBack">
      <button className="bw-event-btn" onClick={() => navigate("/")}>
        <FontAwesomeIcon icon={faChevronLeft} style={{ color: "#1976D2" }} />
        Back
      </button>
    </div>
  );
}
